export function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    // d.setTime(d.getTime() + (2 * 60 * 60 * 1000));
    let expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}
export function getCookie(cname) {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}
export function deleteCookie(cname) {
    document.cookie = cname + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export function removeAllLocalStorage() {
    localStorage.removeItem('Permissions');
    localStorage.removeItem('Email');
    localStorage.removeItem('Role');
    localStorage.removeItem('EmployeeID');
    localStorage.removeItem('celebrationGIF');
}

export function getLocalStorageByName(lsname) {
    let mkLocalData = localStorage.getItem(lsname);
    if (!mkLocalData) {
        mkLocalData = 'null';
    }
    return mkLocalData;
}